import { Phone, CalendarCheck } from 'lucide-react';
import { heroImage } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import { BookNowButton } from './BookNowButton';
import { CALL_TEL } from './constants';

export const Hero = () => {
  const { t } = useLang();
  return (
    <section id="home" className="relative min-h-[92vh] flex items-center pt-[68px]">
      <img
        src={heroImage}
        alt="Turkish barber giving a skin fade in Bray, Co. Wicklow"
        className="absolute inset-0 w-full h-full object-cover"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/68 to-ink" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 w-full">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.28em] uppercase text-gold mb-6">
            {t.hero.badge}
          </p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-[3.25rem] font-bold leading-[1.1] mb-3">
            THE REAL TURKISH BARBER
          </h1>
          <p className="font-serif text-xl sm:text-2xl text-gold mb-5">{t.hero.subtitle}</p>
          <p className="text-base sm:text-lg text-white/75 mb-9 max-w-xl leading-relaxed">{t.hero.desc}</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <BookNowButton
              testId="hero-book-now-button"
              className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-dark text-ink font-bold uppercase tracking-widest px-8 py-4 transition-colors text-sm"
            >
              <CalendarCheck size={18} /> {t.hero.book}
            </BookNowButton>
            <a
              href={CALL_TEL}
              className="inline-flex items-center justify-center gap-2 border border-gold text-gold hover:bg-gold/10 font-bold uppercase tracking-widest px-8 py-4 transition-colors text-sm"
              data-testid="hero-call-now-button"
            >
              <Phone size={18} /> {t.hero.call}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
